/**
 * P3-2 今日跟进配额（sales 工作台顶部强提示）
 */
import { useQuery } from '@tanstack/react-query';
import { $ } from '../../lib/api';

export function QuotaCard() {
  const { data } = useQuery<any>({
    queryKey: ['my-quota'],
    queryFn: () => $.get('/customer-protection/my-quota'),
    refetchInterval: 60_000,
  });
  if (!data) return null;
  const target = data.quotaTarget ?? 10;
  const actual = data.actualCount ?? 0;
  const diff = Math.max(0, target - actual);
  const pct = target > 0 ? Math.min(100, (actual / target) * 100) : 0;
  const done = actual >= target;
  return (
    <div style={{
      padding: '14px 18px', marginBottom: 16,
      background: done ? 'rgba(82,196,26,0.06)' : 'rgba(250,140,22,0.08)',
      border: '1px solid ' + (done ? 'var(--success)' : 'var(--warn)'),
      borderRadius: 8,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
        <span style={{ fontSize: 16, fontWeight: 600 }}>
          {done ? '🎉 今日配额已达成' : `今天还差 ${diff} 个跟进未完成 ⚡`}
        </span>
        <span style={{ marginLeft: 'auto', fontSize: 14, fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>
          {actual} / {target}
        </span>
      </div>
      <div style={{ background: 'var(--bg-3)', height: 8, borderRadius: 4, overflow: 'hidden' }}>
        <div style={{
          width: `${pct}%`, height: '100%',
          background: done ? 'var(--success)' : 'var(--warn)',
          transition: 'width 0.3s',
        }} />
      </div>
    </div>
  );
}
